import fetchFactory from '../../../utils/fetchFactory'
import { configEnum } from '../../../enums/fetchFactoryEnum'

export const POST_CHANGEMENT_APPARTEMENT = 'postChangementAppartement'
export const postChangementAppartement = (data: string) => fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/dossier/changementAppartement`, {
	method: configEnum.post,
	body: data
})
